import type { ReactElement } from 'react';
import RequireClaimRoute from './RequireClaimRoute';

type Props = {
  children: ReactElement;
};

export default function RequireAdminRoute({ children }: Props) {
  return <RequireClaimRoute allowedRoles={['Admin']}>{children}</RequireClaimRoute>;
}